<script>
import LoadingView from '@/views/loading/index.vue'

export default {
  page: {
    title: 'tamara - Page timeout',
    meta: [
      { name: 'description', content: 'The page timed out while loading.' },
    ],
  },
  components: { LoadingView },
}
</script>

<template>
  <LoadingView />
</template>
